import { render, staticRenderFns } from "./EndorsementRejection.vue?vue&type=template&id=68e1d580&scoped=true"
import script from "./EndorsementRejection.vue?vue&type=script&lang=js"
export * from "./EndorsementRejection.vue?vue&type=script&lang=js"
import style0 from "./EndorsementRejection.vue?vue&type=style&index=0&id=68e1d580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1d580",
  null
  
)

export default component.exports